import React, { useCallback, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";

import { Link, useNavigate } from "react-router-dom";
import { CommonSelect, CstmPagination } from "components/Common/Common";
import TableLayout from "components/TableLayout";
import { CHATTER_CLIENT_DETAIL, HOME_EDUCATION_CLIENT_DETAIL, PRIVATE_CLIENT_DETAIL, SCHOOL_CLIENT_DETAIL, SCHOOL_DISCHARGE_DETAILS } from "config/paths";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { CLIENT_TYPES, GRADE_OPTIONS } from "config/constants";
import { useGetDischargeListNewQuery, useGetDischargeListQuery } from "store/services/discharge";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { debounce } from "lodash";
import { userFullName } from "helpers/common";
import { useSchoolLookupQuery } from "store/services/utility";

const SchoolDischarges = () => {

  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filter, setFilter] = useState({ search: "", client_type: "school", grade: "", sort: { column: "id", direction: "desc" } });
  const [inputValue, setInputValue] = useState("");

  const { data: schoolList, isLoading: schoolListLoading, isFetching: schoolListFetching } = useSchoolLookupQuery();
  const schoolListOptions = schoolList?.map((i) => ({ value: i.id, label: i.name }));

  // const { data, isLoading, isError, isFetching } = useGetDischargeListQuery({ page: currentPage, limit: pageSize, ...filter });
  const { data, isLoading, isError, isFetching } = useGetDischargeListNewQuery({ page: currentPage, limit: pageSize, ...filter });
  
  const totalRecords = data?.totalrecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const resetFilter = () => {
    setFilter({ search: "", client_type: "school", grade: "", sort: { column: "id", direction: "desc" } });
    setCurrentPage(1)
    setInputValue("");
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleFilterChange = (key) => (value) => {
    setFilter((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setCurrentPage(1);
  };

  const handleSearchChange = useCallback(debounce((value) => {

    handleFilterChange("search")(value);
  }, 500), []);

  const getTherapistTerm = (data, term) => {
    if (!data?.length) {
      return null;
    }
    const caseload = data?.find((item) => item?.caseDiscipline?.assign_term === term);
    const therapist = caseload?.clientCaseloadMapping?.find((item) => item?.caseTherapist?.therapist_detail?.type === "veteran")?.caseTherapist;
    const TherapistName = userFullName(therapist) || "--";
    const status = caseload?.caseServiceStatus;

    return <div className="d-flex flex-column w-100">
      <span>{TherapistName}</span>
      {status && <span
        style={{ color: status?.id != 16 ? "#000" : "#fff" }}
        className={`${status?.id != 16
          ? "yellowStatus" : "redStatus"
          } status text-capitalize m-0 d-flex align-items-center justify-content-center rounded-pill py-1 px-2 fw-bold mt-1`}
      >{status?.title || null}
      </span>}
    </div>
  }

  const column = [
    {
      head: (
        <>
          <div className="d-flex align-items-center gap-10">
            Last Name
          </div>
        </>
      ),
      accessor: "LastName",
      isComponent: true,
      component: (item, ind) => (
        <div className="d-flex align-items-center gap-10">
          <h6 className="m-0 fw-sbold">{item?.clientCaseloads?.lastname || "--"}</h6>
        </div>
      ),
    },
    {
      head: "First Name",
      accessor: "FirstName",
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item?.clientCaseloads?.firstname || "--"}</h6>
      ),
    },
    {
      head: "Grade",
      accessor: "Grade",
      component: (item, ind) => (
        <>{item?.clientCaseloads?.client_detail?.grade || "--"}</>
      ),
    },
    {
      head: "School",
      accessor: "School",
      component: (item, ind) => (
        <>{item?.clientCaseloads?.client_detail?.client_school_detail?.client_school?.name || "--"}</>
      ),
    },
    // {
    //   head: "SLP ",
    //   accessor: "SLP",
    //   component: (item, ind) => (
    //     <>
    //       {getTherapistTerm(item?.clientCompletedCaseload?.clientCaseloadTherapist, "SLP")}
    //     </>
    //   ),
    // },
    // {
    //   head: "LC",
    //   accessor: "LC",
    //   component: (item, ind) => (
    //     <>
    //       {getTherapistTerm(item?.clientCompletedCaseload?.clientCaseloadTherapist, "LC")}
    //     </>
    //   ),
    // },
    // {
    //   head: "LC",
    //   accessor: "Lc",
    //   component: (item, ind) => (
    //     <>
    //       {getTherapistTerm(item?.clientCompletedCaseload?.clientCaseloadTherapist, "LC")}
    //     </>
    //   ),
    // },
    // {
    //   head: "BC",
    //   accessor: "BC",
    //   component: (item, ind) => (
    //     <>
    //       {getTherapistTerm(item?.clientCompletedCaseload?.clientCaseloadTherapist, "BC")}
    //     </>
    //   ),
    // },
    // {
    //   head: "OT",
    //   accessor: "OT",
    //   component: (item, ind) => (
    //     <>
    //       {getTherapistTerm(item?.clientCompletedCaseload?.clientCaseloadTherapist, "OT")}
    //     </>
    //   ),
    // },
    // {
    //   head: "PT",
    //   accessor: "PT",
    //   component: (item, ind) => (
    //     <>
    //       {getTherapistTerm(item?.clientCompletedCaseload?.clientCaseloadTherapist, "PT")}
    //     </>
    //   ),
    // },
    // {
    //   head: "Consultant",
    //   accessor: "Consultant",
    //   component: (item, ind) => (
    //     <>
    //       {getTherapistTerm(item?.clientCompletedCaseload?.clientCaseloadTherapist, "CONSULTANT")}
    //     </>
    //   ),
    // },
    //  {
    //   head: "Total Case History",
    //   accessor: "Consultant",
    //   component: (item, ind) => (
    //     <>
    //       {item?.total_cases || "--"}
    //     </>
    //   ),
    // },
  ];

  const handleRowClick = (row) => {

    const clientType = row?.clientCaseloads?.client_detail?.client_type;
    let url = "";

    switch (clientType) {

      case "school": url = SCHOOL_CLIENT_DETAIL.replace(":id", row?.clientCaseloads?.id);
        break;

      case "home_education": url = HOME_EDUCATION_CLIENT_DETAIL.replace(":id", row?.clientCaseloads?.id);
        break;

      case "chatter": url = CHATTER_CLIENT_DETAIL.replace(":id", row?.clientCaseloads?.id);
        break;

      case "private": url = PRIVATE_CLIENT_DETAIL.replace(":id", row?.clientCaseloads?.id);
        break;

      default: url = ""
        break;
    };

    if (url) navigate(url);
  };

  return (
    <>
      <section className="designations position-relative py-4">
        <Container fluid>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left">
                  <TableHeader
                    heading="Discharges"
                    hideSearch
                    handleFilterChange={handleFilterChange}
                    filter={filter}
                    resetFilter={resetFilter}
                    filterComponent={
                      <>
                        <li>
                        <div className="d-flex align-items-center px-2">
                          <label>Client Type: </label>
                            <CommonSelect
                              placeholder={"Select Client Type"}
                              value={CLIENT_TYPES?.find(x => x.value == filter?.client_type)}
                              option={CLIENT_TYPES}
                              onChange={(e) => handleFilterChange("client_type")(e.value)}
                              isFilter
                            />
                          </div>
                        </li>
                        <li>
                          <CommonSelect
                            placeholder={"Select School"}
                            option={schoolListOptions}
                            onChange={(e) => handleFilterChange("school")(e)}
                            value={filter?.school}
                            isFilter
                            isLoading={schoolListLoading || schoolListFetching}
                          />
                        </li>
                        <li>
                          <CommonSelect
                            placeholder={"Select Grade"}
                            option={GRADE_OPTIONS}
                            onChange={(e) => handleFilterChange("grade")(e)}
                            value={filter?.grade}
                            isFilter
                          />
                        </li>
                      </>
                    }
                  ></TableHeader>
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                    <li className="">
                      <Form>
                        <div className="iconWithText position-relative">
                          <span
                            className="icn position-absolute"
                            style={{ left: 10 }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M14.2621 15.5742L9.27139 10.8848C8.81306 11.2632 8.28598 11.5594 7.69014 11.7733C7.09431 11.9872 6.47793 12.0941 5.841 12.0941C4.27426 12.0941 2.9483 11.5517 1.86312 10.4668C0.777942 9.38192 0.235352 8.05626 0.235352 6.48983C0.235352 4.92356 0.777789 3.59744 1.86266 2.5115C2.94754 1.42571 4.27319 0.882812 5.83962 0.882812C7.4059 0.882812 8.73201 1.4254 9.81796 2.51058C10.9037 3.59576 11.4466 4.92172 11.4466 6.48846C11.4466 7.14311 11.3368 7.76835 11.1171 8.36419C10.8973 8.96002 10.604 9.47824 10.2373 9.91886L15.228 14.608L14.2621 15.5742ZM5.841 10.7193C7.02212 10.7193 8.02251 10.3094 8.84216 9.48962C9.66197 8.66997 10.0719 7.66958 10.0719 6.48846C10.0719 5.30733 9.66197 4.30694 8.84216 3.48729C8.02251 2.66749 7.02212 2.25758 5.841 2.25758C4.65987 2.25758 3.65948 2.66749 2.83983 3.48729C2.02003 4.30694 1.61012 5.30733 1.61012 6.48846C1.61012 7.66958 2.02003 8.66997 2.83983 9.48962C3.65948 10.3094 4.65987 10.7193 5.841 10.7193Z"
                                fill="#1C1B1F"
                              />
                            </svg>
                          </span>
                          <span
                            className="icn position-absolute"
                            style={{ right: 10 }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <g opacity="0.5">
                                <path
                                  d="M10.33 16.593H4.0293"
                                  stroke="#071E3E"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M13.1406 6.89969H19.4413"
                                  stroke="#071E3E"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M8.72629 6.84625C8.72629 5.5506 7.66813 4.5 6.36314 4.5C5.05816 4.5 4 5.5506 4 6.84625C4 8.14191 5.05816 9.19251 6.36314 9.19251C7.66813 9.19251 8.72629 8.14191 8.72629 6.84625Z"
                                  stroke="#071E3E"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M19.9997 16.5533C19.9997 15.2576 18.9424 14.207 17.6374 14.207C16.3316 14.207 15.2734 15.2576 15.2734 16.5533C15.2734 17.8489 16.3316 18.8995 17.6374 18.8995C18.9424 18.8995 19.9997 17.8489 19.9997 16.5533Z"
                                  stroke="#071E3E"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </g>
                            </svg>
                          </span>
                          <input
                            type="text"
                            placeholder="Client First, Last Name"
                            className="form-control"
                            style={{ height: 40, padding: "0 30px" }}
                            onChange={(e) => {
                              setInputValue(e.target.value);
                              handleSearchChange(e.target.value);
                            }}
                            value={inputValue}
                          />
                        </div>
                      </Form>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="table-outer">
                {isLoading ? (
                  <div style={{ height: "200px" }}>
                    <LoadingIndicator />
                  </div>
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching) && <LoadingOverlay />}
                    <TableLayout
                      data={data?.records || []}
                      handleRowClick={handleRowClick}
                      column={column}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SchoolDischarges;
